module.exports = __webpack_public_path__ + "img/waitMFC.b75bd931.png";